import gql from "graphql-tag";

const EVENTREPORT_EXPORT_QUERY = gql`
  query EventReportExport(
    $assetsSelected: [Int]!
    $driversSelected: [Int]
    $typeEventSelected: [Int]
    $fechaInicio: Datetime
    $fechaFin: Datetime
    $days: [WeekDaysEnum]
    $hideAutoreports: Boolean
    $format: FormatEnum
  ) {
    eventReportExport(
      assetsSelected: $assetsSelected
      driversSelected: $driversSelected
      typeEventSelected: $typeEventSelected
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      days: $days
      hideAutoreports: $hideAutoreports
      format: $format
    )
  }
`;

export default EVENTREPORT_EXPORT_QUERY;
